<template>
  <div id="app">
    <Loader v-if="$route.name !== 'Login' && $store.state.isLoading" />
    <Nav v-if="$route.name !== 'Login'"  />
    <router-view/>
    <Notice v-if="$store.state.organisation.subdomain == 'thebe-extra' && $route.name !== 'Login'" />

  
    <Footer v-if="$route.name !== 'Login'" />
  </div>
</template>

<script>
import Nav from '@/components/Nav';
import Loader from '@/components/Loader';
import Footer from '@/components/Footer';
import Notice from '@/components/Notice';

export default {
  name: 'App',
  components: {
    Nav,
    Footer,
    Loader,
    Notice,
  },
  mounted(){
    this.$store.dispatch('GET_CONTENT');
  //  alert('0')
  }
}
</script>

<style lang="scss">
@import '/assets/scss/app.scss';

</style>
